<template>
    <div>
        <div class="register-wrapper">
            <div id="register">
                <p class="title">建立培训机构用户账号</p>
                <el-form
                    :model="ruleForm2"
                    status-icon
                    :rules="rules2"
                    ref="ruleForm2"
                    label-width="0"
                    class="demo-ruleForm"
                >
                    <el-form-item prop="name">
                        <el-input v-model="ruleForm2.name" auto-complete="off" placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input
                            type="password"
                            v-model="ruleForm2.password"
                            auto-complete="off"
                            placeholder="输入密码"
                        ></el-input>
                    </el-form-item>
                    <!-- <el-form-item prop="checkPass">
            <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="确认密码"></el-input>
                    </el-form-item>-->
                    <el-form-item prop="zuzhi" label="城市" label-width="60px">
                        <!-- <span style="float:left;margin-right:20px;">城市</span> -->
                        <el-cascader
                            expand-trigger="hover"
                            v-model="ruleForm2.zuzhi"
                            :options="options"
                            :props="list"
                            ref="orgSelect"
                            :show-all-levels="false"
                            style="float:left;"
                        ></el-cascader>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm()" style="width:100%;">注册</el-button>
                        <p class="login" @click="gotoLogin">已有账号？立即登录</p>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import { nextTick } from 'q'
import { mapMutations } from 'vuex'
// import qs from 'qs'
export default {
    name: 'Login',
    data() {
        return {
            options: [],
            list: {
                value: 'id',
                label: 'name',
                emitPath: false,
                checkStrictly: true 
            },
            // *name用户名 *pass密码
            ruleForm2: {
                name: '',
                password: '',
                zuzhi: ''
            },
            rules2: {
                name: [
                    { required: true, message: '请设置账号', trigger: 'blur' },
                    { min: 6, message: '请至少输入6位字符', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, message: '请至少输入6位数密码', trigger: 'blur' }
                ],
                zuzhi: [{ required: true, message: '请选择', trigger: 'blur' }]
            },
            flag: true,
            dialogVisible: false
        }
    },
    created() {
        this.option()
    },
    methods: {
        // <!--提交注册-->
        submitForm() {
            this.$refs.ruleForm2.validate(valid => {
                if (valid) {
                    let data = {
                        username: this.ruleForm2.name,
                        password: this.ruleForm2.password,
                        orgId: this.ruleForm2.zuzhi,
                        platformId: localStorage.getItem('datas')
                    }
                    var qs = require('qs')
                    this.$axios
                        .post(
                            this.$managePath + '/offline/api/org/settledIn',
                            qs.stringify(data),
                            {
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                }
                            }
                        )
                        .then(res => {
                            this.token = res.data.data
                            this.changeLogin(this.token)
                            var storage = window.localStorage
                            alert('注册成功,继续完善信息')
                            this.$emit('pactive',1)
                            // this.dialogVisible = true;
                        })
                        .catch(res => {
                            console.log('err')
                        })
                }
            })
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done()
                })
                .catch(_ => {})
        },
        option() {
            let platformId = localStorage.getItem('datas')
            this.$axios
                .get(this.$managePath + '/offline/api/org/getArea', {
                    params: { platformId }
                })
                .then(res => {
                    let list = res.data.data
                    function getOption() {
                        let pidStr = 'parentId'
                        let idStr = 'id'
                        let childrenStr = 'children'
                        let listObj = {}
                        let treeList = []
                        for (let i = 0; i < list.length; i++) {
                            listObj[list[i][idStr]] = list[i]
                        }
                        for (let j = 0; j < list.length; j++) {
                            let haveParent = listObj[list[j][pidStr]]
                            if (haveParent) {
                                !haveParent[childrenStr] &&
                                    (haveParent[childrenStr] = [])
                                haveParent[childrenStr].push(list[j])
                            } else {
                                treeList.push(list[j])
                            }
                        }
                        return treeList
                    }
                    var a = getOption()
                    this.options = a
                })
                .catch(res => {
                    console.log('err')
                })
        },
        // },
        // <!--进入登录页-->
        gotoLogin() {
            window.location.href = this.$managePath
        }
    },
    watch:{
        "ruleForm2.zuzhi": function() {
            if (this.$refs.orgSelect) {
                this.$refs.orgSelect.dropDownVisible = false //监听值发生变化就关闭它
            }
        }
    }
}
</script>
<style scoped>
.loading-wrapper {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: #aedff8;
    display: flex;
    align-items: center;
    justify-content: center;
}
.register-wrapper img {
    position: absolute;
    z-index: 1;
}
.register-wrapper {
    position: fixed;
    top: 20%;
    right: 0;
    left: 0;
    bottom: 0;
}
#register {
    max-width: 340px;
    margin: 60px auto;
    background: #fff;
    padding: 20px 40px;
    border-radius: 10px;
    position: relative;
    z-index: 9;
}
.title {
    font-size: 16px;
    line-height: 50px;
    font-weight: bold;
    margin: 10px;
    text-align: left;
}
.el-form-item {
    text-align: center;
}
.login {
    margin-top: 10px;
    font-size: 14px;
    line-height: 22px;
    color: #1ab2ff;
    cursor: pointer;
    text-align: left;
    text-indent: 8px;
    width: 160px;
}
.login:hover {
    color: #2c2fd6;
}
.code >>> .el-form-item__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.code button {
    margin-left: 20px;
    width: 140px;
    text-align: center;
}
.el-button--primary:focus {
    background: #409eff;
    border-color: #409eff;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue